import {
  Message, MessageBox,
} from 'element-ui';
import dayjs from 'dayjs';
const util = {
  // 年级键值对
  gradeObj: {
    '01': '一年级',
    '02': '二年级',
    '03': '三年级',
    '04': '四年级',
    '05': '五年级',
    '06': '六年级',
    '11': '初一',
    '12': '初二',
    '13': '初三',
    '21': '高一',
    '22': '高二',
    '23': '高三',
  },
  // 年级信息转化
  getGrade(scope) {
    if (!scope) return '';
    let arr = scope.split(','),
      str = '';
    arr.forEach((item, i) => {
      if (this.gradeObj[item]) {
        str += this.gradeObj[item];
        if (i < arr.length - 1) {
          str += ',';
        }
      }
    });
    return str;
  },
  // 参数验证
  checkData(obj) {
    for (let i in obj) {
      if (!obj[i].skip) {
        if (typeof obj[i].value === 'object') {
          if (!obj[i].value.length) {
            Message.error(obj[i].title + '不能为空');
            return false;
          }
        } else {
          if (!obj[i].value) {
            Message.error(obj[i].title + '不能为空');
            return false;
          }
        }
      }
    }
    return true;
  },
  extList: [{
    label: 'audio',
    ext: ['mp3', 'ogg', 'wav', 'm4a', 'mav', 'wma', 'aac']
  }, {
    label: 'doc',
    ext: ['doc', 'docx']
  }, {
    label: 'excel',
    ext: ['xlsx', 'xltx', 'xls', 'csv']
  }, {
    label: 'img',
    ext: ['gif', 'png', 'jpg', 'bmp', 'tiff', 'image', 'jpeg', 'jfif']
  }, {
    label: 'video',
    ext: ['mp4', 'rmvb', 'mkv', 'avi', 'flv', 'wmv', 'mpeg', 'm4v', 'mpe', 'mpg', 'mov', '3gp']
  }, {
    label: 'pdf',
    ext: ['pdf']
  }, {
    label: 'ppt',
    ext: ['ppt', 'pptx']
  }, {
    label: 'link',
    ext: ['htm', 'html', 'php', 'xhtml', 'url']
  }],

  getFileExt(fileName) {
    return fileName.substring((fileName.lastIndexOf(".") + 1)).toLocaleLowerCase();
  },

  getFileType(ext) {
    if (!ext) {
      return 'default';
    }
    let obj = this.extList.find(data => {
      return data.ext.includes(ext.toLocaleLowerCase());
    });
    if (!obj) {
      return 'default';
    }
    return obj.label;
  },
  handleCofirm(text = '确定执行此操作吗？', type = 'info') {
    return MessageBox.confirm(text, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: type,
      center: true,
      width: 300,
    })
  },
  getRequest() {
    var url = window.location.search; //获取url中"?"符后的字串  
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        //就是这句的问题
        theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        //之前用了unescape()
        //才会出现乱码  
      }
    }
    return theRequest;
  },
  // 算出今天是本学期的第几周
  TodayInfo(start) {
    var WEEKLEN = 7, // 一周7天为常量
      WEEKDAYS = ["日", "一", "二", "三", "四", "五", "六"],
      weekInfo = { "week": null, "day": null }, // 初始化返回信息，默认第null周，星期null
      oneDay = 24 * 60 * 60 * 1000, // 一天的毫秒时长
      weekLeave, // 开学当天所在周剩余天数
      weekStart, // 开学当天start是星期几
      today, // 今天
      dateDiff, // 今天与开学当天日期差
      sDate; //开学之日，日期对象
    var rDateStr = /\d{4}[\/-]\d{1,2}[\/-]\d{1,2}/g; // 简单的日期格式校验：2013/12/19
    if (!rDateStr.test(start)) {
      console.log("请使用合法的开学日期！！！");
      return weekInfo;
    }
    sDate = new Date(start);
    weekStart = sDate.getDay();
    weekStart = weekStart === 0 ? 7 : weekStart; // JS中周日的索引为0，这里转换为7，方便计算

    weekLeave = WEEKLEN - weekStart;
    today = new Date();
    weekInfo.day = WEEKDAYS[today.getDay()];
    today = new Date(today.getFullYear() + "/" + (today.getMonth() + 1) + "/" + today.getDate());
    dateDiff = today - sDate;
    if (dateDiff < 0) {
      console.log("别开玩笑了，你还没开学呢！！！");
      return weekInfo;
    }
    dateDiff = parseInt(dateDiff / oneDay);
    weekInfo.week = Math.ceil((dateDiff - weekLeave) / WEEKLEN) + 1;
    // console.log('计算周','start',start,'sDate',sDate,'weekStart',weekStart,'dateDiff',dateDiff,'today',today,'weekLeave',weekLeave);
    return weekInfo;
  },
  // 获取每学期1到20周数组, 并附带每周的日期, 例如 第1周 2022-02-14至2022-02-20
  showCourse(startDate) {
    var start = new Date(startDate);
    var nowTime = start.getTime();
    var day = start.getDay();
    var oneDayTime = 24 * 60 * 60 * 1000;
    // 开学日期所在周的星期一
    var MondayTime = nowTime - (day - 1) * oneDayTime;
    // console.log('开学',startDate, MondayTime);
    // 周列表
    let weekList = []
    for (let week = 1; week < 21; week++) {//默认星期一为每周的起点
      //开始查询日期
      let date = new Date(MondayTime);
      // 星期一
      date.setDate(date.getDate() + (week - 1) * 7);
      let one = date.getFullYear() + "-" + ((date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + "-" + (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate());
      // 重置
      date = new Date(MondayTime);
      // 星期天
      date.setDate(date.getDate() + (week - 1) * 7 + 6);
      let seven = date.getFullYear() + "-" + ((date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + "-" + (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate());
      weekList.push({
        id: week,
        label: '第' + week + '周' + '（' + one + '至' + seven + '）'
      })
      // console.log('第'+week+'周','星期一',one,'星期天',seven)
    }
    return weekList;
  },
  // 获取当前的学期学年
  getYearlySemester(){
    let yearlySemester=''
    let currentTime  = new Date();
    let year = currentTime.getFullYear();
    let month = currentTime.getMonth() + 1;
    if(month>=9 || month<=2 ){
      yearlySemester=`${year}-${year+1}学年上学期`
    }else{
      yearlySemester=`${year-1}-${year}学年下学期`
    }
    return yearlySemester
  },
  // 获取当前一天的数据
  getNowDate() {
    let time = (new Date).getTime() - 24 * 60 * 60 * 1000;
    let yesterday = new Date(time);
    let dateTime = yesterday.getFullYear() + "" + (yesterday.getMonth() + 1 > 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "" + (yesterday.getDate() > 9 ? (yesterday.getDate()) : "0" + (yesterday.getDate()));
    return dateTime;
  },
  // 获取当前一天的数据 '-'格式
  getNowDateRung() {
    let time = (new Date).getTime() - 24 * 60 * 60 * 1000;
    let yesterday = new Date(time);
    let dateTime = yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1 > 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "-" + (yesterday.getDate() > 9 ? (yesterday.getDate()) : "0" + (yesterday.getDate()));
    return dateTime;
  },
  //qrBase64是后台传回来的base64数据
  handleDownloadQrIMg(qrBase64) {
    // 这里是获取到的图片base64编码,这里只是个例子哈，要自行编码图片替换这里才能测试看到效果
    const imgUrl = `data:image/png;base64,${qrBase64}`
    // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
    if (window.navigator.msSaveOrOpenBlob) {
      const bstr = atob(imgUrl.split(',')[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      const blob = new Blob([u8arr])
      window.navigator.msSaveOrOpenBlob(blob, 'chart-download' + '.' + 'png')
    } else {
      // 这里就按照chrome等新版浏览器来处理
      const a = document.createElement('a')
      a.href = imgUrl
      a.setAttribute('download', 'chart-download')
      a.click()
    }
  },
  // 保留小数点后两位，整数的直接返回
  numFilter(value) {
    let realVal = ''
    if (parseFloat(value) % 1 === 0) {
      realVal = parseFloat(value)
    }
    else if (!isNaN(value) && value !== '') {
      // 截取当前数据到小数点后两位
      realVal = parseFloat(value).toFixed(2)
    } else {
      realVal = '-'
    }
    return realVal
  },
  //将时间戳转为日期格式
  timestampToTime(timestamp) {
    var date
    //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    if (timestamp.toString().length == 10) {
      date = new Date(timestamp * 1000)
    } else {
      date = new Date(timestamp)
    }
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() + ' ';
    var h = date.getHours() + ':';
    var m = date.getMinutes() + ':';
    var s = date.getSeconds();
    // return Y+M+D+h+m+s;
    return Y + M + D;
  },
  // 计算截止日期还剩多久
  endDistance(startDate, endDate) {
    var y, d, h, m, s;
    // 获取相差毫秒数
    var leftTime = endDate.getTime() - startDate.getTime();
    // 转化时间

    // 1000毫秒 = 1秒
    // 60秒 = 1分钟
    // 60分钟 = 1小时
    // 60小时 = 1日
    d = Math.floor(leftTime / 1000 / 60 / 60 / 24) || '';
    let d_str = d ? d + '日' : '';

    // 所以利用 % 求余运算符，就可以将其 除于小时或小时或分数 然后将余数赋值，见下例
    // 天数剩下的余数就是剩下的小时
    h = Math.floor((leftTime / 1000 / 60 / 60) % 24) || '';
    let h_str = h ? h + '时' : '';

    // 小时剩下的余数就是剩下的分钟
    m = Math.floor((leftTime / 1000 / 60) % 60) || '';
    let m_str = m ? m + '分' : '';

    // 分数剩下的余数就是剩下的秒数
    s = Math.floor((leftTime / 1000) % 60) || '';
    let s_str = s ? s + '秒' : '';
    return d_str + h_str + m_str; //+ s_str;
  },
  // 展现上课时间对应的课节
  filterClassTimeName(data) {
    const gradeObj = {
      1: "早自习",
      2: "第一节",
      3: "第二节",
      4: "第三节",
      5: "第四节",
      6: "中自习",
      7: "第五节",
      8: "第六节",
      9: "第七节",
      10: "第八节",
      11: "晚自习",
    };
    let str = "";
    if (data && data.classTimeName && data.sectionNum) {
      let classTimeNameList = data.classTimeName.split(",");
      let sectionNumList = data.sectionNum.split(",");
      for (let i = 0; i < classTimeNameList.length; i++) {
        let isD =
          classTimeNameList.length === 1 || i === classTimeNameList.length - 1
            ? ""
            : " , ";
        str +=
          gradeObj[sectionNumList[i]] == undefined ? "" : gradeObj[sectionNumList[i]] +
            "(" +
            classTimeNameList[i] +
            ")" +
            isD;
      }
    }
    return str;
  },
  // 判断当前时间是否在当前学期学年内
  isWeekInData(data) {
    let nowDate = dayjs(new Date().getTime()).format('YYYY-MM-DD')
    let res = false
    data.forEach(it => {
      if (it.semesterDateList && it.semesterDateList.length > 0) {
        it.semesterDateList.forEach(j => {
          if (j && j.date && j.date.indexOf(nowDate) != -1) {
            res = true
          }
        })
      }
    })
    return res
  },
  // 随机生成ID
  randomId() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (
      S4() +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      S4() +
      S4()
    );
  },
  jsonDownLoadExcel(JSONData, FileName, title, keys) {
    if (!JSONData) { return }
    // 转化json为object
    var arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData

    // 设置数据
    for (var i = 0; i < arrData.length; i++) {
      var row = '<tr>'
      for (var k in title) {
        if (!keys[k]) {
          row += "<td style='border: 1px solid #ddd;height:36px;line-height:36px;MSO-NUMBER-FORMAT:\"\@\"'></td>"
        } else {
          row += "<td  style='border: 1px solid #ddd;height:36px;line-height:36px;MSO-NUMBER-FORMAT:\"\@\"' align='center'>" + arrData[i][keys[k]] + '</td>'
        }
      }
      excel += row + '</tr>'
    }

    excel += '</table>'

    var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>"
    excelFile += '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">'
    excelFile += '<head>'
    excelFile += '<!--[if gte mso 9]>'
    excelFile += '<xml>'
    excelFile += '<x:ExcelWorkbook>'
    excelFile += '<x:ExcelWorksheets>'
    excelFile += '<x:ExcelWorksheet>'
    excelFile += '<x:Name>'
    excelFile += '{worksheet}'
    excelFile += '</x:Name>'
    excelFile += '<x:WorksheetOptions>'
    excelFile += '<x:DisplayGridlines/>'
    excelFile += '</x:WorksheetOptions>'
    excelFile += '</x:ExcelWorksheet>'
    excelFile += '</x:ExcelWorksheets>'
    excelFile += '</x:ExcelWorkbook>'
    excelFile += '</xml>'
    excelFile += '<![endif]-->'
    excelFile += '</head>'
    excelFile += '<body>'
    excelFile += excel
    excelFile += '</body>'
    excelFile += '</html>'

    var uri = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(excelFile)

    var link = document.createElement('a')
    link.href = uri

    link.style = 'visibility:hidden'
    link.download = FileName + '.xls'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },
  // 前端通过拼接字符串模板导出
  downloadExcel(JSONData, FileName, title) {
    if (!JSONData) { return }
    // 转化json为object
    var arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData
    console.log('88888888888888888', arrData);
    var excel = "<table style='table-layout: fixed;width: 100%;'> "
    excel += "thead><tr style='background: #f7f7f7'><th style='width: 180px; height: 50px; position: relative;' colspan='2'>"
    excel += "<span style=' position: absolute;color: #000;left: 20px;bottom: 10px;'> 班级/课节 </span><div style='position: absolute;width: 1px; height: 197px;top: 0; left: 0; background-color: #dddddd; transform: rotate(-73.5deg);transform-origin: top;'></div> <span style='position: absolute;color: #000; right: 20px; top: 10px;'>日期</span></th>"
    for (var i = 0; i < title.length; i++) {
      var thRow = '<th>'
      thRow += "<p>" + title[i].value + "</p>" + "<p>" + title[i].date + "</p>"
      excel += thRow + '</th>'
    }
    excel += "</tr></thead>"
    excel += "<tbody>"
    for (var i = 0; i < arrData.length; i++) {
      var row = '<tr> '
      row += "<td :rowspan=" + arrData[i].courseNamerow + "v-if=" + !arrData[i].courseNameshow + "style='background: #f7f7f7'>"
      row += "<p style='font-weight: bold; color: #000'>" + arrData[i].courseName + "</p></td>"
      row += "<td><p>" + arrData[i].courseData + "</p></td>"
      console.log('每一个课表:' + arrData[i].courseList.length);
      for (var i = 0; i < arrData[i].courseList.length; i++) {
        // console.log('每一个课表:'+arrData[i].courseList);
        var tdRow = '<td>'
        tdRow += "<div> <p style='font-weight: bold; color: #000'>" + arrData[i].courseList.courseName + "</p>"
        tdRow += "<p><span>" + arrData[i].courseList.extOrgName + "</span></p>"
        tdRow += "<p>" + arrData[i].courseList.locationName + "</p>"
        tdRow += "<p>" + arrData[i].courseList.currentClassNum + "/" + arrData[i].courseList.classNum + "</p>"
        tdRow += "<p>报名数/招生数：<span>" + arrData[i].courseList.selectedCount + "/" + arrData[i].courseList.totalLimit != 99999 ? arrData[i].courseList.totalLimit : "不限" + "</span></p></div>"
        excel += tdRow + '</td>'
      }
      excel += row + '</tr>'
    }
    excel += "</tbody>"
    excel += '</table>'

    var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>"
    excelFile += '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">'
    excelFile += '<head>'
    excelFile += '<!--[if gte mso 9]>'
    excelFile += '<xml>'
    excelFile += '<x:ExcelWorkbook>'
    excelFile += '<x:ExcelWorksheets>'
    excelFile += '<x:ExcelWorksheet>'
    excelFile += '<x:Name>'
    excelFile += '{worksheet}'
    excelFile += '</x:Name>'
    excelFile += '<x:WorksheetOptions>'
    excelFile += '<x:DisplayGridlines/>'
    excelFile += '</x:WorksheetOptions>'
    excelFile += '</x:ExcelWorksheet>'
    excelFile += '</x:ExcelWorksheets>'
    excelFile += '</x:ExcelWorkbook>'
    excelFile += '</xml>'
    excelFile += '<![endif]-->'
    excelFile += '</head>'
    excelFile += '<body>'
    excelFile += excel
    excelFile += '</body>'
    excelFile += '</html>'

    var uri = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(excelFile)

    var link = document.createElement('a')
    link.href = uri

    link.style = 'visibility:hidden'
    link.download = FileName + '.xls'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

}

export default util;